'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _elements = require('../../elements');

var _constants = require('../../utils/constants');

var _em2rem = require('../../utils/em2rem');

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FONT_SIZE = 12;

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.textLight + ';\n  display: inline-block;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(FONT_SIZE) + ';\n  font-weight: ' + theme.fontWeights.light + ';\n  line-height: ' + (0, _em2rem2.default)(FONT_SIZE, _constants.TEXT_LINE_HEIGHT) + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  text-decoration: none;\n  text-transform: capitalize;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  fontWeights: _propTypes2.default.shape({
    light: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TabList.ItemLink', (0, _styledComponents2.default)(_elements.NavLink), styles, { themePropTypes: themePropTypes });


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/TabList/ItemLink.js
// module id = 1610
// module chunks = 2